import { SVGProps, Ref, forwardRef } from 'react';

export const ThumbUpFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.357 3.023C9.478 1.53 11.085.537 12.5 1.211c1.484.708 2 2.163 2 3.787v3H19c3.406.105 4.38 1.403 3.876 4.993l-.703 5c-.523 3.724-1.945 4.983-5.673 5h-9V7.795c1.091-1.576 1.717-3.058 1.857-4.772M5.7 9.003c-3.509.142-4.7 1.54-4.7 5.322v3.333c0 3.78 1.191 5.18 4.7 5.321z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ThumbUpFilledSize24Glyph.displayName = 'ThumbUpFilledSize24Glyph';
